
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import PieChartFilterable from '@/components/reports-v3/components/filterables/PieChartFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import gdbx from '@/store/modules/gdbx';

@Component({
	components: {
		PieChartFilterable,
	},
})
export default class SupplierUnAppliedAmountPieChart extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['suppliers'];
	}

	public filterIds: Array<
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf', 'suppliers', 'agents'];

	public pieDatas: Array<{ name: string; value: number }> = [];

	public get expensiveHook() {
		const { selectedAsOfDate, selectedAgents, selectedSuppliers } = this;
		return JSON.stringify([
			selectedAsOfDate,
			selectedAgents,
			selectedSuppliers,
		]);
	}

	public async expensiveCalc() {
		const jobId = this.currentJobId;
		this.generateLoadingText(0.2, 0.4);

		const queryHead = await this._ensureTablesLoaded(
			['supplierTrades'] as any[],
		);
		this.checkInterrupted(jobId);
		this.generateLoadingText(0.4, 0.9);

		const tradesTable = getTableName('supplierTrades');
		const dateFilter = `TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}`;
		const escapeStr = (s: string) => s.replace(/'/g, '\'\'');

		const allAgentLen = (gdbx.allAgents && gdbx.allAgents.length) || 0;
		const agentFilter = this.selectedAgents && this.selectedAgents.length > 0
			&& this.selectedAgents.length !== allAgentLen
			? ` AND "AGENT" IN (${this.selectedAgents.map((a: string) => `'${escapeStr(a)}'`).join(', ')})`
			: '';

		const allSupplierLen = (gdbx.allSuppliers && gdbx.allSuppliers.length) || 0;
		const supplierFilter = this.selectedSuppliers && this.selectedSuppliers.length > 0
			&& this.selectedSuppliers.length !== allSupplierLen
			? ` AND "CODE" IN (${this.selectedSuppliers.map((s: string) => `'${escapeStr(s)}'`).join(', ')})`
			: '';

		const result = await queryHead.rawQuery(`
			SELECT
				SUM(CASE WHEN "DOCTYPE" = 'SC' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as sc,
				SUM(CASE WHEN "DOCTYPE" = 'ST' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as st,
				SUM(CASE WHEN "DOCTYPE" = 'SI' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as si,
				SUM(CASE WHEN "DOCTYPE" = 'SP' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as sp,
				SUM(CASE WHEN "DOCTYPE" = 'SF' THEN TRY_CAST("LOCALUNAPPLIEDAMT" AS DOUBLE) ELSE 0 END) as sf
			FROM ${tradesTable}
			WHERE ${dateFilter}${agentFilter}${supplierFilter}
				AND "DOCTYPE" IN ('SC', 'ST', 'SI', 'SP', 'SF')
		`);
		this.checkInterrupted(jobId);
		this.generateLoadingText(1);

		const row = result[0] || {};

		this.pieDatas = [
			{ name: 'Credit Note', value: Number(row.sc) || 0 },
			{ name: 'Contra', value: Number(row.st) || 0 },
			{ name: 'Deposit', value: Number(row.si) || 0 },
			{ name: 'Payment', value: Number(row.sp) || 0 },
			{ name: 'Refund', value: Number(row.sf) || 0 },
		];

		this.saveHistory('pieDatas');
	}
}
